import {cdnImgUrl} from "@/utils/ImageUrl";

export default {
    getCamStudyUser: (state, getters, rootState, rootGetters) => (userId) => {
        if(!userId) {
            userId = rootGetters["user/me"].userId
        }
       return state.camStudyUserList.find(user => user.userId === userId)
    },
    userProfileImage: (state, getters, rootState, rootGetters) => (userId) => {
        const cUser = getters.getCamStudyUser(userId);
        if(!cUser) return '';
        let path = cUser?.profileImageUrl;
        if(!path){
            return '';
        }
        if(path.startsWith('http')){
            return path;
        }
        return cdnImgUrl(path);
    },
    enteredCamStudyUserList: (state, getters, rootState, rootGetters) => {
      const roomUserIdList = rootGetters['user/roomUserList'].map(ru => ru.userId)
      return state.camStudyUserList.filter(cu => roomUserIdList.includes(cu.userId))
    },
    getUserStudyData: (state) => (userId) => {
        return state.studyDataList.find(sd => sd.userId === userId)
    },
    getUserStopwatch: (state) => (userId) => {
        return state.stopWatchList.find(sw => sw.userId === userId)
    },
    camStudy: (state) => {
        return state.camStudy;
    },
    isUserScreenBlock: (state) => (userId) => {
        return !!state.screenBlockList[userId]
    },
    banReasonList: (state) => {
        return state.banReasonList
    },
    getBanReason: (state) => (reason) => {
        return state.banReasonList.find(banReason => banReason.reason === reason)
    },
    banUserList: (state) => {
        return state.camStudyUserBanList
    },
    camStudyUserList: (state) => {
      return state.camStudyUserList
    },
    whiteNoisePlayList: (state) => {
        return state.whileNoisePlayList
    },
    personalSetting: (state, getters, rootState, rootGetters) => {
        return state.personalSetting
    },
    getHashTagList: (state) => {
        return state.hashTagList
    },
    currentWhiteNoise: (state) => {
        return state.currentWhiteNoise
    },
    getRoomImageUrl: (state) => {
        return state.roomImageUrl
    },
    studyInfoSetting: (state) => {
        return state.myStudyInfoSetting
    },
    getRoomImagePath: (state) => {
        return state.roomImagePath
    },
    mainDDay: (state) => {
        return state.dDayList.find(d => d.selected)
    },
    getStopWatchSetting: (state) => {
        return state.stopWatchSetting
    },
    isAttend: (state, getters) => (userId) => {
        if(!userId) return false

        const studyData = getters.getUserStudyData(userId)

        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 1을 더해줌
        const dd = String(today.getDate()).padStart(2, '0');
        const formattedToday = `${yyyy}${mm}${dd}`
        return formattedToday === studyData?.userStudyId
    },
    getUserPremiumLevel: (state) => {
        return state.userPremiumLevel;
    },
    // featureType: 'BLUR', 'FACE_MASK'
    isUserTrialEnabledBy: (state, getters, rootState, rootGetters) => (featureType) => {
        const trial = state?.userTrialList.find(trial => trial.featureType === featureType)
        const isPremium = rootGetters['room/isPremiumRoom'];
        if (isPremium) {
            return true;
        }

        if (!trial) {
            return false;
        }

        return trial.enabled
    }
};
